import { LoginRequestDto } from 'record-it-time-common/dto/auth/LoginRequestDto';
import { LoginResponseDto } from 'record-it-time-common/dto/auth/LoginResponseDto';
import {
  CreateUserRequestDto,
  CreateUserResponseDto
} from 'record-it-time-common/dto/synchronization/CreateUserDto';
import { ExportWorkTimeCsvRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeCsvRequestDto';
import { ExportWorkTimeCsvResponseDto } from 'record-it-time-common/dto/export/ExportWorkTimeCsvResponseDto';
import { SendPasswordResetMailRequestDto } from 'record-it-time-common/dto/auth/SendPasswordResetMailRequestDto';
import { ResetPasswordRequestDto } from 'record-it-time-common/dto/auth/ResetPasswordRequestDto';
import { ChangePasswordRequestDto } from 'record-it-time-common/dto/auth/ChangePasswordRequestDto';
import { DefaultAppResponse } from 'record-it-time-common/AppResponse';
import { ApiRequester } from '../ApiRequester/ApiRequester';
import { ExportWorkTimeTimesheetRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeTimesheetRequestDto';
import { ExportWorkTimeConstructionSiteRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeConstructionSiteRequestDto';
import { ExportWorkTimeConstructionSiteSummaryRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeConstructionSiteSummaryRequestDto';
import { ExportWorkTimeActivitiesRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeActivitiesRequestDto';
import { ExportWorkTimeTimesheetForUserGroupRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeTimesheetForUserGroupRequestDto';
import { ExportWorkTimeFullExportRequestDto } from 'record-it-time-common/dto/export/ExportWorkTimeFullExportRequestDto';

export class ApiAdapter {
  public static async login(data: LoginRequestDto): Promise<LoginResponseDto> {
    return ApiRequester.postJson('/auth/login', {
      body: data
    });
  }

  public static async createUser(
    data: CreateUserRequestDto
  ): Promise<CreateUserResponseDto> {
    return ApiRequester.postJson('/user', {
      body: data
    });
  }

  public static async exportWorkTimeCsv(
    data: ExportWorkTimeCsvRequestDto
  ): Promise<ExportWorkTimeCsvResponseDto> {
    return ApiRequester.postJson('/export/workTime/csv', {
      body: data
    });
  }

  public static async exportWorkTimeTimesheet(
    data: ExportWorkTimeTimesheetRequestDto
  ): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/timesheet', {
      body: data
    });
  }

  public static async exportWorkTimeAllTimesheets(
    data: ExportWorkTimeTimesheetForUserGroupRequestDto
  ): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/allTimesheetsForUserGroup', {
      body: data
    });
  }

  public static async exportWorkTimeConstructionSite(
    data: ExportWorkTimeConstructionSiteRequestDto
  ): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/constructionSite', {
      body: data
    });
  }

  public static async exportWorkTimeConstructionSiteSummary(
    data: ExportWorkTimeConstructionSiteSummaryRequestDto
  ): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/constructionSiteSummary', {
      body: data
    });
  }

  public static async exportWorkTimeActivities(
    data: ExportWorkTimeActivitiesRequestDto
  ): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/activities', { body: data });
  }

  public static async exportWorkTimeFullExport(
    data: ExportWorkTimeFullExportRequestDto
  ): Promise<Blob> {
    return ApiRequester.postFile('/export/workTime/full', { body: data });
  }

  public static async sendPasswordResetEmail(
    data: SendPasswordResetMailRequestDto
  ): Promise<DefaultAppResponse> {
    return ApiRequester.postJson('/auth/sendPasswordResetMail', {
      body: data
    });
  }

  public static async resetPassword(
    data: ResetPasswordRequestDto
  ): Promise<DefaultAppResponse> {
    return ApiRequester.postJson('/auth/resetPassword', {
      body: data
    });
  }

  public static async changePassword(
    data: ChangePasswordRequestDto
  ): Promise<DefaultAppResponse> {
    return ApiRequester.postJson('/auth/changePassword', {
      body: data
    });
  }
}
